import { Button as AntdButton } from '~/ui/components';
import styled from 'styled-components';
import { themeToggleColor } from '~/common/utils/theme';

export const Button = styled(AntdButton).attrs(({ theme }) => ({
  variant: 'contained',
  customColor: themeToggleColor(theme, 'element.primary', { dark: 'brand.secondaryAlt' }),
}))``;
